module.exports = __webpack_public_path__ + "static/page-7-69d254cc32ed8d045b0c023be8d392fd.jpg";